import {observer} from 'mobx-react-lite'
import type {Stores} from '../../../../../util/store'
import {useUserById} from '../../../../../stores/user-store'
import {formatUserName} from '../../../../../util/format'

export interface RegisteredManufacturerCellProps {
    userId: string | null
    stores: Stores
}

export const ReviewedByCell = observer<RegisteredManufacturerCellProps>(
    ({ userId, stores }) => {
        const user = useUserById(stores.users, userId)

        if (user) {
            return formatUserName(user) ?? user.id
        }

        return (
            <span
                style={{
                    color: 'var(--comment-color)',
                    fontSize: '0.8rem',
                    fontStyle: 'italic',
                }}>
                not reviewed
            </span>
        )
    },
)
